import metrics from 'maps/metrics';

const thisWeekToDate = metrics.twtd;
const lastWeek = metrics.lw;
const rtd = metrics.rtd;

/**
 * This function constructs the array needed to populate the
 * sorting metric dropdown on mobile.
 *
 * @returns {Array} the options the user can sort by.
 */
export default function getMobileSortingOptions(): any {
  return [
    thisWeekToDate,
    {
      ...metrics[thisWeekToDate.change as string],
      label: thisWeekToDate.label,
    },
    lastWeek,
    { ...metrics[lastWeek.change as string], label: lastWeek.label },
    rtd,
  ];
}
